module.exports = __webpack_public_path__ + "static/media/3-hybrid.431e4b83.png";